import Vue from "vue";
import localeElement from "element-ui/lib/locale";
import VueI18n from "vue-i18n";
import messages from "./langs";
Vue.use(VueI18n);

let thelang = localStorage.getItem('locale');
if (!thelang) {
  let langdefault = navigator.language;
  switch (langdefault) {
    case 'zh-CN':
      thelang = 'cn';
      break;
    case 'zh-TW':
      thelang = 'cntw';
      break;
    case 'zh-HK':
      thelang = 'cntw';
      break;
    case 'en':
      thelang = 'en';
      break;
    default:
      thelang = "cntw";
      localStorage.setItem('locale',thelang);
  }
} else {
  switch (thelang) {
    case 'zh-CN':
      thelang = 'cn';
      break;
    case 'zh-TW':
      thelang = 'cntw';
      break;
    case 'zh-HK':
      thelang = 'cntw';
      break;
    case 'en':
      thelang = 'en';
      break;
  }
}


const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "cntw",
  fallbackLocale: thelang || "cntw",
  messages
});

localeElement.i18n((key, value) => i18n.t(key, value)); //为了实现element插件的多语言切换

window.$i18n = i18n;// 目的为了在需要页面进行动态国际化后台数据
export default i18n
